import { useState } from "react";
import { X } from "lucide-react";

export const DEFAULT_CONTRACT_TAGS = ["soulbound", "faucet"];

export default function TagInput({
    value = [],
    onChange,
    suggestions = DEFAULT_CONTRACT_TAGS,
    placeholder = "Add a tag and press Enter",
    label,
}) {
    const [input, setInput] = useState("");

    const normalize = (tag) => tag.trim().toLowerCase();

    const addTag = (tag) => {
        const normalized = normalize(tag);
        if (!normalized || value.includes(normalized)) {
            setInput("");
            return;
        }
        onChange([...value, normalized]);
        setInput("");
    };

    const removeTag = (tag) => {
        onChange(value.filter((t) => t !== tag));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            addTag(input);
        } else if (e.key === "Backspace" && !input && value.length > 0) {
            removeTag(value[value.length - 1]);
        }
    };

    const availableSuggestions = suggestions.filter((s) => !value.includes(s));

    return (
        <div>
            {label && (
                <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
            )}
            <div className="flex flex-wrap items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-2 py-1.5 min-h-[42px] focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
                {value.map((tag) => (
                    <span
                        key={tag}
                        className="inline-flex items-center gap-1 rounded-full bg-blue-100 text-blue-700 px-2 py-0.5 text-xs font-medium"
                    >
                        {tag}
                        <button
                            type="button"
                            onClick={() => removeTag(tag)}
                            className="text-blue-500 hover:text-blue-800"
                            aria-label={`Remove ${tag}`}
                        >
                            <X size={12} />
                        </button>
                    </span>
                ))}
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={() => input && addTag(input)}
                    placeholder={value.length === 0 ? placeholder : ""}
                    className="flex-1 min-w-[120px] border-0 outline-none text-sm bg-transparent py-1"
                />
            </div>
            {availableSuggestions.length > 0 && (
                <div className="flex flex-wrap items-center gap-1.5 mt-2">
                    <span className="text-xs text-slate-500">Suggested:</span>
                    {availableSuggestions.map((tag) => (
                        <button
                            key={tag}
                            type="button"
                            onClick={() => addTag(tag)}
                            className="inline-flex items-center gap-0.5 rounded-full border border-slate-300 bg-slate-50 text-slate-600 hover:bg-slate-100 hover:border-slate-400 px-2 py-0.5 text-xs transition-colors"
                        >
                            + {tag}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
